package com.varabyte.kobweb.showcase.site.worker

import com.varabyte.kobweb.worker.Attachments
import com.varabyte.kobweb.worker.WorkerContext
import org.w3c.dom.Worker
import kotlin.js.Json
import kotlin.js.json

class FetchShowcaseWorker(override var onOutput: WorkerContext.(output: com.varabyte.kobweb.showcase.site.model.ShowcaseSiteResponse) -> Unit = {}) :
    com.varabyte.kobweb.worker.Worker<com.varabyte.kobweb.showcase.site.model.ShowcaseSiteRequest, com.varabyte.kobweb.showcase.site.model.ShowcaseSiteResponse> {

    private val ioSerializer = com.varabyte.kobweb.showcase.site.worker.FetchShowcaseWorkerFactory().createIOSerializer()

    private val worker = Worker("/_kobweb/workers/com-varabyte-kobweb-showcase-site-worker/worker-18fc.js").apply {
        onmessage = { e ->
            val json = e.data.unsafeCast<Json>()
            val outputDeserialized = try {
                ioSerializer.deserializeOutput(json["_output"] as String)
            } catch (e: Throwable) {
                console.warn(buildString {
                    append("Unable to deserialize output generated by worker, ignoring it.")
                    e.message?.let { append("\nException: $it") }
                })
                null
            }
            if (outputDeserialized != null) {
                val ctx = WorkerContext(Attachments.fromJson(json))
                ctx.onOutput(outputDeserialized)
            }
        }
    }

    override fun postInput(input: com.varabyte.kobweb.showcase.site.model.ShowcaseSiteRequest, attachments: Attachments) {
        val inputSerialized = try {
            ioSerializer.serializeInput(input)
        } catch (e: Throwable) {
            console.warn(buildString {
                append("Unable to serialize argument when calling `FetchShowcaseWorker.postInput(com.varabyte.kobweb.showcase.site.model.ShowcaseSiteRequest)`, ignoring the call.")
                e.message?.let { append("\nException: $it") }
            })
            null
        }
        if (inputSerialized != null) {
            worker.postMessage(
                json("_input" to inputSerialized).add(attachments.toJson()),
                attachments.toValues()
            )
        }
    }

    override fun terminate() {
        worker.terminate()
    }
}